import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';
import {addCacheBuster} from '../utils/url';

export function getMemberFollowed(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: addCacheBuster('/member/followers/'),
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberFollowed.js